package org.hs_soft.runmynesto.pages.home.sub_page.media_center.component.media_center_content.tabs.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.margin
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.media_center.tabs.media.DisplaySizeEnum
import org.hs_soft.runmynesto.domain.model.home.media_center.tabs.media.media_detail.WithProduct
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.IdUtils
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.domain.util.openLocalForUniqueSelectingFile
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.components.UploadImage

@Composable
fun Advertising(
    windowSizeMode: WindowSizeModeEnum,
    mediaImg169: String?,
    mediaImg: String?,
    selectedDisplaySize: DisplaySizeEnum,
    selectedArticles: List<WithProduct>?,
    updateMediaBase64Img: (String, String) -> Unit,
    setDisplaySize: (DisplaySizeEnum) -> Unit,
    showArticleDialog: () -> Unit,
    deleteArticle:(String)->Unit,
) {
    Column(
        modifier = Modifier
            .margin(right = Dimen.largePadding)
    )
    {
        MediumContentTitle(
            title = Strings.current().fullDisplayAdvertising,
        )

        DropDownItem(
            modifier = Modifier,
            itemWidth = Dimen.semiLargeEditTextWidth,
            options = DisplaySizeEnum.entries,
            label = "",
            selectedItem = selectedDisplaySize,
            displayText = { item ->
                if (item is DisplaySizeEnum) item.title else ""
            },
            onOptionClick = {
                if (it is DisplaySizeEnum){
                    setDisplaySize(it)
                }
            }
        )

        UploadImage(
            height =if (selectedDisplaySize==DisplaySizeEnum.STANDARD)
                Dimen.selectRectPhoneHeight else Dimen.selectRectPhoneWidth ,
            modifier = Modifier
                .margin(top = Dimen.mediumPadding),
            imgUrl = mediaImg169,
            setImageDirectlyStatus = true,
            imgId = IdUtils.fullDisplayAdvertising,
            onImgContentClick = {
                openLocalForUniqueSelectingFile(IdUtils.fullDisplayAdvertising)
            },
            setImageDirectly = { file ->
                updateMediaBase64Img(
                    file,
                    ApiUtils.Type.Media9_16
                )
            }
        )

    }

    Column(
        modifier = Modifier
            .margin(right = Dimen.largePadding)
    )
    {
        MediumContentTitle(
            title = Strings.current().advertisingDuringTyping,
            marginBottom = Dimen.normalPadding,
        )

        UploadImage(
            imgUrl = mediaImg,
            setImageDirectlyStatus = true,
            imgId = IdUtils.advertisingDuringTyping,
            onImgContentClick = {
                openLocalForUniqueSelectingFile(IdUtils.advertisingDuringTyping)
            },
            setImageDirectly = { file ->
                updateMediaBase64Img(
                    file,
                    ApiUtils.Type.Media
                )
            }
        )


    }

    Column()
    {
        MediumContentTitle(
            title = Strings.current().chooseAnArticle,
            marginBottom = Dimen.normalPadding,
        )

        ChooseAnArticle(
            selectedArticles = selectedArticles,
            windowSizeMode = windowSizeMode,
            onBoxClick = {
                showArticleDialog()
            },
            deleteArticle = {
                deleteArticle(it)
            }
        )
    }

}

